module.exports = __webpack_public_path__ + "static/assets/88ab038784badd192df6bd931d7c2e40.svg";